import { Typography } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import Picture from 'components/picture';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';
import { parseStringifiedJSON } from 'utils/parse-string';

import { DEFAULT_PRODUCT_CARD_HEIGHT_DESKTOP, DEFAULT_PRODUCT_CARD_HEIGHT_MOBILE } from './styled';

interface IProductCardDisabledProps {
  name?: string;
  image?: string;
}

export const ProductCardDisabled = ({ name, image }: IProductCardDisabledProps) => {
  const isMobile = useIsMobileBreakpoint();

  const defaultProductCardHeight = isMobile
    ? DEFAULT_PRODUCT_CARD_HEIGHT_MOBILE
    : DEFAULT_PRODUCT_CARD_HEIGHT_DESKTOP;

  const unavailableMessage = t('temporarilyUnavailable', {
    defaultValue: 'Temporarily unavailable',
  });

  return (
    <View style={styles.wrapper}>
      <View style={[styles.container, { height: defaultProductCardHeight }]}>
        <View style={styles.dimmer}>
          <View style={styles.productCartdContent}>
            {image && (
              <View style={styles.imageContainer}>
                {image && (
                  <Picture
                    width="full"
                    flex={1}
                    image={parseStringifiedJSON({ value: image })}
                    alt={name ?? ''}
                    accessibilityHidden
                    objectFitContain={true}
                  />
                )}
              </View>
            )}
          </View>
          <View style={styles.footer}>
            <View style={styles.nameContainer}>
              <Typography
                fontSize="sm"
                textAlign="center"
                numberOfLines={2}
                bold
                maxFontSizeMultiplier={2}
              >
                {name ?? ''}
              </Typography>
              <Typography variant="copyTwo" textAlign="center">
                {unavailableMessage}
              </Typography>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    padding: spacing.$1,
    width: '33.33%',
  },
  container: {
    backgroundColor: primitive.$whiteOpacity10,
    alignItems: 'center',
    borderWidth: 2,
    borderColor: primitive.$blackOpacity10,
    borderStyle: 'solid',
    borderRadius: primitive.$borderRadius,
    overflow: 'hidden',
    minHeight: spacing.$40,
    padding: spacing.$2,
  },
  dimmer: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    opacity: 0.6,
  },
  productCartdContent: {
    width: '100%',
    height: 80,
  },
  imageContainer: {
    flex: 1,
    width: '100%',
    padding: 0,
    margin: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  footer: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
  },
  nameContainer: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    gap: spacing.$2,
  },
});
